import axios, { InternalAxiosRequestConfig, AxiosResponse } from 'axios';

import { errorHandler, responseHandler, TIMEOUT } from './http-common';

import { apiAddress, monitorApiAddress } from '../config';

const requestHandler = (request: InternalAxiosRequestConfig) => {
    request.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
    return request;
};

const axiosMonitorAPI = axios.create({
    baseURL: monitorApiAddress,
    timeout: TIMEOUT,
});

axiosMonitorAPI.interceptors.request.use(
    (request) => requestHandler(request),
    (error) => errorHandler(error),
);

axiosMonitorAPI.interceptors.response.use(
    (response) => responseHandler(response),
    (error) => Promise.reject(errorHandler(error)),
);

export default axiosMonitorAPI;
